<template>
    <!--PC注册-->
    <div>
        <ZhaiHeadPC class="zhai-head"></ZhaiHeadPC>
        <div class="container-fluid shengse px-0 deng">
            <div class="dixian px-4 py-2 d-flex justify-content-between">
                <div><i class="bi bi-person-fill-add lf"></i>&nbsp;用户注册</div>
            </div>
            <div class="px-5 zhai-s">
                <div class="mb-3">
                    <input
                            type="text"
                            class="form-control"
                            :class="{ 'is-invalid': errors.username }"
                            id="username"
                            v-model="myform.username"
                            placeholder="请输入用户名"
                            @keyup.enter="reg"
                    >
                </div>
                <div class="mb-3">
                    <input
                            type="password"
                            class="form-control"
                            :class="{ 'is-invalid': errors.password }"
                            id="password"
                            v-model="myform.password"
                            placeholder="请输入密码"
                            @keyup.enter="reg"
                    >
                </div>
                <div class="mb-3">
                    <input
                            type="password"
                            class="form-control"
                            :class="{ 'is-invalid': errors.password2 }"
                            id="password2"
                            v-model="myform.password2"
                            placeholder="请再次确认密码"
                            @keyup.enter="reg"
                    >
                </div>
                <div class="mb-3">
                    <input
                            type="email"
                            class="form-control"
                            :class="{ 'is-invalid': errors.email }"
                            id="exampleFormControlInput4"
                            v-model="myform.email"
                            placeholder="邮箱"
                            @keyup.enter="reg"
                    >
                </div>
                <CaptchaComponent
                        @validate-captcha="validateCaptcha"
                        ref="captchaComponent"
                ></CaptchaComponent>
                <div class="mt-1">
                    <p class="qing">请记住用户名，并填写真实邮箱，否则无法找回密码</p>
                </div>
                <div class="col-12 zhucce text-center">
                    <button type="button" @click="reg" class="btn btn-success w-100 anniu">注册</button>
                </div>

                <div class="zhan"></div>
            </div>
        </div>
        <ZhaiFootPC></ZhaiFootPC>

        <div class="modal fade" id="errorModal" tabindex="-1" aria-labelledby="errorModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-shake" style="max-width: 300px;">
                <div class="modal-content shake">
                    <div class="modal-body d-flex align-items-center justify-content-center">
                        <i class="bi bi-emoji-frown" style="font-size: 2rem; color: #dc3545;"></i>
                        <p class="mb-0 ms-2" style="font-size: 1rem; color: #dc3545;">{{ errorMessage }}</p>
                    </div>
                </div>
            </div>
        </div>
        <!-- 成功模态框 -->
        <div class="modal fade" id="successModal" tabindex="-1" aria-labelledby="successModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" style="max-width: 200px;">
                <div class="modal-content">
                    <div class="modal-body d-flex align-items-center justify-content-center">
                        <i class="bi bi-emoji-smile" style="font-size: 2rem; color: #00c26f;"></i>
                        <p class="mb-0 ms-2" style="font-size: 1rem; color: #00c26f;">注册成功</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import http from "../utils/http.js"; // 导入自定义的http请求工具，用于与后端通信
    import ZhaiHeadPC from "../componentspc/ZhaiHeadPC"; // 导入PC端头部组件
    import ZhaiFootPC from "../componentspc/ZhaiFootPC"; // 导入PC端底部组件
    import { Modal } from "bootstrap"; // 导入Bootstrap的Modal组件，用于模态框
    import CaptchaComponent from "../componentspc/CaptchaComponent.vue"; // 引入验证码组件

    export default {
        name: "PRegister", // 组件名称
        components: { ZhaiHeadPC, ZhaiFootPC, CaptchaComponent }, // 注册使用的子组件

        data() {
            return {
                myform: {
                    username: "", // 用户名
                    password: "", // 密码
                    password2: "", // 确认密码
                    email: "" // 邮箱
                },
                errors: {}, // 存储各字段的错误状态
                errorMessage: "", // 错误提示信息
                captchaValid: false, // 验证码是否有效

                // ✅ 只用 iuid
                iuid: null
            };
        },

        methods: {
            /* =========================
               1️⃣ iuid 工具（只认 iuid）
            ========================== */

            // 从当前 URL 获取 iuid
            getIuidFromUrl() {
                const params = new URLSearchParams(window.location.search);
                return (params.get("iuid") || "").trim();
            },

            // iuid 必须是 5 位数字
            isValidIuid(iuid) {
                return /^\d{5}$/.test(String(iuid || "").trim());
            },

            // 保存 iuid（默认 7 天）
            saveIuid(iuid) {
                const expireTime = Date.now() + 7 * 24 * 60 * 60 * 1000;
                const data = { iuid: String(iuid).trim(), expire: expireTime };
                localStorage.setItem("inviteData", JSON.stringify(data));
            },

            // 读取缓存 iuid（自动处理过期/脏数据）
            getSavedIuid() {
                const raw = localStorage.getItem("inviteData");
                if (!raw) return null;

                try {
                    const data = JSON.parse(raw);
                    if (!data || !data.iuid || !data.expire) {
                        localStorage.removeItem("inviteData");
                        return null;
                    }

                    const iuid = String(data.iuid).trim();
                    const expire = Number(data.expire);

                    if (!this.isValidIuid(iuid) || !expire || Date.now() > expire) {
                        localStorage.removeItem("inviteData");
                        return null;
                    }

                    return iuid;
                } catch (e) {
                    localStorage.removeItem("inviteData");
                    return null;
                }
            },

            // 最终可用 iuid：URL 优先，其次缓存
            resolveIuid() {
                const fromUrl = this.getIuidFromUrl();
                if (this.isValidIuid(fromUrl)) return fromUrl;

                const fromCache = this.getSavedIuid();
                if (this.isValidIuid(fromCache)) return fromCache;

                return null;
            },

            /* =========================
               2️⃣ 验证码
            ========================== */

            // 验证验证码是否有效
            validateCaptcha(isValid) {
                this.captchaValid = isValid;
                this.$refs.captchaComponent.captchaError = !isValid;
            },

            /* =========================
               3️⃣ 注册
            ========================== */

            reg() {
                this.errors = {};

                // 验证用户名
                if (!this.myform.username.trim()) {
                    this.showErrorModal("用户名不能为空", "username");
                    return;
                }
                if (
                    this.myform.username.length < 4 ||
                    this.myform.username.length > 20 ||
                    this.myform.username.includes(" ")
                ) {
                    this.showErrorModal("用户名必须介于4-20个字符且不能包含空格", "username");
                    return;
                }

                // 验证密码
                if (!this.myform.password.trim()) {
                    this.showErrorModal("密码不能为空", "password");
                    return;
                }
                if (!/^[^\s]{6,15}$/.test(this.myform.password)) {
                    this.showErrorModal("密码应为6-15位字符且不能包含空格", "password");
                    return;
                }

                // 验证两次密码
                if (this.myform.password !== this.myform.password2) {
                    this.showErrorModal("两次密码不一致", "password2");
                    return;
                }

                // 验证邮箱
                if (!this.myform.email.trim()) {
                    this.showErrorModal("邮箱不能为空", "email");
                    return;
                }
                if (!this.validateEmail(this.myform.email)) {
                    this.showErrorModal("邮箱格式有误", "email");
                    return;
                }

                // 验证验证码是否为空
                if (!this.$refs.captchaComponent.enteredCaptcha.trim()) {
                    this.showErrorModal("验证码不能为空", "captcha");
                    this.$refs.captchaComponent.captchaError = true;
                    return;
                }

                // 校验验证码
                this.validateCaptcha(
                    this.$refs.captchaComponent.enteredCaptcha.trim() ===
                    this.$refs.captchaComponent.captchaText
                );

                if (!this.captchaValid) {
                    this.showErrorModal("图形验证码输入不正确！", "captcha");
                    return;
                }

                // 准备提交数据
                const url = "/platform/frontEnd/register";
                const fm = new FormData();
                fm.append("username", this.myform.username);
                fm.append("password", this.myform.password);
                fm.append("password2", this.myform.password2);
                fm.append("email", this.myform.email);

                // ✅ 核心：注册时永远尽力带上 iuid（URL 或缓存）
                const iuid = this.resolveIuid();
                this.iuid = iuid;

                if (this.isValidIuid(iuid)) {
                    fm.append("iuid", iuid);
                    console.log("注册携带 iuid:", iuid);
                } else {
                    console.log("注册未携带 iuid（URL与缓存均无有效值）");
                }

                // 发起注册请求
                http
                    .post(url, fm, true)
                    .then((data) => {
                        if (data.data.status === 1) {
                            this.autoLogin();
                        } else {
                            this.handleFormErrors(data.data);
                        }
                    })
                    .catch((error) => {
                        console.error("注册请求失败:", error);
                        this.showErrorModal("注册请求失败，请稍后重试。");
                    });
            },

            /* =========================
               4️⃣ 自动登录
            ========================== */

            autoLogin() {
                const url = "/platform/frontEnd/login";
                const fm = new FormData();
                fm.append("username", this.myform.username);
                fm.append("password", this.myform.password);

                http
                    .post(url, fm, { untoken: true })
                    .then((response) => {
                        if (response.data.status === 1 && response.data.data) {
                            const data = response.data.data;

                            const userData = {
                                user: {
                                    id: data.id,
                                    username: data.username,
                                    email: data.email,
                                    level: data.level,
                                    level_expire_date: data.level_expire_date
                                },
                                token: data.token
                            };

                            if (!userData.user || !userData.token) {
                                this.showErrorModal("登录失败，用户或令牌无效");
                                return;
                            }

                            // 存储用户数据
                            this.$store.dispatch("login", userData);
                            localStorage.setItem("authToken", userData.token);
                            localStorage.setItem("user", JSON.stringify(userData.user));

                            // ✅ 注册成功后清除 iuid 缓存（避免误归因）
                            localStorage.removeItem("inviteData");

                            this.showSuccessModal();
                        } else {
                            this.showErrorModal(response.data.msg || "登录失败！");
                        }
                    })
                    .catch(() => {
                        this.showErrorModal("请求失败，请稍后重试。");
                    });
            },

            /* =========================
               5️⃣ 模态框/UI工具
            ========================== */

            showSuccessModal() {
                const modalElement = document.getElementById("successModal");
                const modal = new Modal(modalElement);
                modal.show();

                setTimeout(() => {
                    modal.hide();
                    this.$router.push("/memberCenter");
                }, 3000);
            },

            validateEmail(email) {
                const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                return re.test(email);
            },

            handleFormErrors(data) {
                if (data.field && data.message) {
                    this.showErrorModal(data.message, data.field);
                } else {
                    this.showErrorModal(data.msg || "注册失败！");
                }
            },

            showErrorModal(message, field) {
                this.errorMessage = message;
                if (field) {
                    this.errors[field] = true;
                }

                const modalElement = document.getElementById("errorModal");
                const modal = new Modal(modalElement);
                modal.show();

                // 抖动效果
                setTimeout(() => {
                    const content = modalElement.querySelector(".modal-content");
                    if (content) {
                        content.classList.add("shake");
                        setTimeout(() => content.classList.remove("shake"), 1000);
                    }
                }, 0);

                setTimeout(() => {
                    modal.hide();
                }, 3000);
            }
        },

        mounted() {
            this.$refs.captchaComponent.generateCaptcha();

            // ✅ 进入注册页时捕获一次 iuid（只认 iuid）
            const fromUrl = this.getIuidFromUrl();
            if (this.isValidIuid(fromUrl)) {
                this.saveIuid(fromUrl);
                console.log("注册页捕获 iuid:", fromUrl);
            }

            // ✅ 初始化当前可用 iuid（供 reg() 使用/日志）
            this.iuid = this.resolveIuid();
            console.log("注册页最终可用 iuid:", this.iuid);
        }
    };
</script>


<style scoped>
    .zhai-s {
        padding-top: 20px;
    }
    .br5 {
        border-radius: 1px;
    }
    .zhan {
        height: 30px;
    }
    .btn-success {
        background-color: #00c26f !important;
        font-size: 0.9rem;
        border: none !important;
    }
    .deng {
        max-width: 35%;
        margin: 0 auto;
    }
    .form-control {
        font-size: 0.85rem;
        padding: 0.5rem 0.6rem; /* 增加输入框的行高 */
        border-radius: 4px; /* 调整四个圆角的大小 */
    }
    .zhucce {
        margin-top: 15px;
    }
    @media (min-width: 768px) {
        .zhai-head {
            position: fixed;
            top: 0;
            width: 100%;
            z-index: 1000;
        }
        .container-fluid {
            margin-top: 100px !important;
        }
    }
    @keyframes shake {
        0%, 100% { transform: translateX(0); }
        10%, 30%, 50%, 70%, 90% { transform: translateX(-2px); }
        20%, 40%, 60%, 80% { transform: translateX(2px); }
    }
    .modal-content.shake {
        animation: shake 0.5s;
    }
    .qing {
        font-size: 0.85rem;
        color: red;
    }
    .is-invalid {
        border-color: #dc3545 !important;
        background-image: none !important; /* 移除叹号图标 */
    }
    .modal-body {
        padding: 0px !important; /* 将内边距设置为0px，并使用 !important 覆盖原有样式 */
    }
</style>
